const rightsObject = {
  "user-management": {
    type: Boolean,
  },
  "waitlist-management": {
    type: Boolean,
  },
  "failed-consultation-management": {
    type: Boolean,
    label: "Cancelled Consultation",
  },
  "missed-call-chat-management": {
    type: Boolean,
    label: "Missed Chat/Call",
  },
  "completed-call-chat-management": {
    type: Boolean,
    label: "Completed Chat/Call",
  },
  "completed-queries-management": {
    type: Boolean,
    label: "Completed Queries",
  },
  "progress-call-chat-management": {
    type: Boolean,
    label: "Progress Chat/Call",
  },
  "online-offline-consultant-management": {
    type: Boolean,
    label: "Consultant Online/Offline",
  },
  "flag-request-management": {
    type: Boolean,
    label: "Flag Requests",
  },
  "booked-waitlist-management": {
    type: Boolean,
    label: "Booked Session-Waitlist",
  },
  "consultant-management": {
    type: Boolean,
  },
  "performance-alerts-management": {
    type: Boolean,
    label: "Performance Alerts",
  },
  "operations-ecosystem-management": {
    type: Boolean,
    label: "Operations Ecosystem",
  },
  "operations-desk-1-management": {
    type: Boolean,
    label: "Operations Ecosystem Desk 1",
  },
  "operations-desk-2-management": {
    type: Boolean,
    label: "Operations Ecosystem Desk 2",
  },
  "operations-desk-3-management": {
    type: Boolean,
    label: "Operations Ecosystem Desk 3",
  },
  "operations-whatsapp-offers-management": {
    type: Boolean,
    label: "Operations Ecosystem WhatsApp Offers",
  },
  "power-customer-return-management": {
    type: Boolean,
    label: "Power Customer Return",
  },
  "pre-selected-consultant-management": {
    type: Boolean,
    label: "Pre Selected Consultant",
  },
  "astrologer-registration-management": {
    type: Boolean,
    label: "Astrologer Registration Form",
  },
  "expertise-management": {
    type: Boolean,
  },
  "banner-management": {
    type: Boolean,
  },
  "ecommerce-management": {
    type: Boolean,
  },
  "music-management": {
    type: Boolean,
  },
  "meditation-management": {
    type: Boolean,
  },
  "training-management": {
    type: Boolean,
  },
  "gallery-management": {
    type: Boolean,
  },
  "content-management": {
    type: Boolean,
  },
  "vastu-management": {
    type: Boolean,
  },
  "gift-management": {
    type: Boolean,
  },
  "community-management": {
    type: Boolean,
  },
  "explore-management": {
    type: Boolean,
  },
  "refer-management": {
    type: Boolean,
  },
  "request-management": {
    type: Boolean,
  },
  "discount-management": {
    type: Boolean,
  },
  "horoscope-management": {
    type: Boolean,
  },
  "live-management": {
    type: Boolean,
  },
  "support-management": {
    type: Boolean,
  },
  "feedback-management": {
    type: Boolean,
  },
  "notification-management": {
    type: Boolean,
  },
  "concern-management": {
    type: Boolean,
  },
  "transaction-management": {
    type: Boolean,
  },
  "offers-management": {
    type: Boolean,
  },
  "offer-management": {
    type: Boolean,
    label: "Offer Management",
  },
  "coupon-management-v2": {
    type: Boolean,
    label: "Coupon Management V2",
  },
  "influencer-management": {
    type: Boolean,
    label: "Influencer Management",
  },
  "marketing-management": {
    type: Boolean,
    label: "Marketing Purpose",
  },
  "dashboard-matrix-analytics": {
    type: Boolean,
  },
  "insight-management": {
    type: Boolean,
  },
  "analytics-management": {
    type: Boolean,
  },
  "sub-admin-management": {
    type: Boolean,
    label: "Subadmin Management",
  },
  "shopify-commission-management": {
    type: Boolean,
    label: "Shopify Commission",
  },
  "consultant-payout-management": {
    type: Boolean,
    label: "Consultant Payout",
  },
  "bank-pan-request-management": {
    type: Boolean,
  },
  "bank-pan-record-management": {
    type: Boolean,
  },
  // "playstore-management": {
  //   type: Boolean,
  // },
  "playstore-screenshot-management": {
    type: Boolean,
  },
  "purchase-analytics-management": {
    type: Boolean,
  },
  "utm-management": {
    type: Boolean,
    label: "UTM Management",
  },
  "zodiac-message-management": {
    type: Boolean,
  },
  "customer-problem-management": {
    type: Boolean,
    label: "Customer Problem Identification",
  },
  "appstore-management": {
    type: Boolean,
  },
  "webstore-management": {
    type: Boolean,
  },
  "dashboard-management": {
    type: Boolean,
    label: "Dashboard",
  },
  "daily-consult-performance-management": {
    type: Boolean,
    label: "Daily Consult Performance",
  },
  "marketing-dashboard-management": {
    type: Boolean,
    label: "Power Customer",
  },
  "activity-log-management": {
    type: Boolean,
    label: "Activity Log",
  },
  "cron-jobs-management": {
    type: Boolean,
    label: "Cron Jobs",
  },
  // Claude Data Analysis is admin-only — not assignable to sub-admins
  "segment-management": {
    type: Boolean,
  },
  "settings-management": {
    type: Boolean,
    label: "Settings",
  },
};

export const rights = Object.keys(rightsObject).map((key) => ({
  name:
    rightsObject[key].label ||
    key
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .replace(/Management/g, "Management"),
  value: key,
  status: false,
}));
